<template>
  <b-table
    :data="scaleProductsBaseWithPriceAndMargin"
    narrowed
    hoverable
    id="scale-products-table"
  >
    <b-table-column
      field="code"
      :label="$t('products.code')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">{{ props.row.code }}</span>
    </b-table-column>

    <b-table-column
      field="n"
      :label="$t('common.name')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">{{ props.row.n }}</span>
    </b-table-column>

    <b-table-column
      field="lc"
      :label="$t('products.cost')"
      sortable
      v-slot="props"
      v-if="permissions.seeProductCostTableColumn"
    >
      <span class="adjust-top">
        {{ `${payments.currencySymbol}${formatMoney(props.row.lc)}` }}
        / {{ props.row.unit }}
      </span>
    </b-table-column>

    <b-table-column
      field="p"
      :label="$t('products.price')"
      sortable
      v-slot="props"
    >
      <money
        v-model="props.row.p"
        v-bind="money"
        class="input is-expanded"
        @blur.native="updatePrice(props.row)"
        @focus.native="registerOriginalPrice(props.row.p)"
        style="width: 100px"
        :disabled="!permissions.addProductToCatalogUpdatePrice"
      ></money>

      <span class="adjust-top"> / {{ props.row.unit }}</span>
    </b-table-column>

    <b-table-column
      field="m"
      :label="$t('products.margin')"
      sortable
      v-slot="props"
      v-if="permissions.seeProductMarginTableColumn"
    >
      <span class="adjust-top">
        {{
          props.row.hasOwnProperty("m") && !isNaN(props.row.m)
            ? `${(props.row.m * 100).toFixed(1)} %`
            : "-"
        }}
      </span>
    </b-table-column>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"></b-icon>
          </p>
          <p>{{ $t("common.tableEmptyMessage") }}</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import { Money } from "v-money";

export default {
  props: ["storeBeingManaged", "scaleProducts"],

  mixins: [common, mask],

  components: {
    Money
  },

  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      },
      initialPrice: ""
    };
  },

  methods: {
    registerOriginalPrice(price) {
      this.initialPrice = price;
    },

    updatePrice(product) {
      if (product.p !== this.initialPrice) {
        const p = Number(String(product.p.toFixed(2)).replace(/[^0-9]+/g, ""));
        this.$emit("update-scale-product-price", {
          product: { ...product, p },
          storeId: this.storeBeingManaged._id
        });
      }
    }
  },

  computed: {
    ...mapGetters(["scaleProductsBase", "permissions", "payments"]),

    scaleProductsBaseWithPriceAndMargin() {
      let s = JSON.parse(JSON.stringify(this.scaleProductsBase));

      const scaleProductsIndexes = [];
      for (let i = 0; i < this.scaleProducts.length; i++) {
        scaleProductsIndexes[this.scaleProducts[i].code] = i;
      }

      s = s.map(s => {
        if (scaleProductsIndexes.hasOwnProperty(s.code)) {
          let p = this.scaleProducts[scaleProductsIndexes[s.code]].p;
          s = {
            ...s,
            p,
            m: (p - s.lc / 100) / p
          };
        }
        return s;
      });

      return s;
    }
  },

  mounted() {
    this.money.prefix = `${this.payments.currencySymbol} `;
  }
};
</script>

<style scoped>
.adjust-top {
  position: relative;
  top: 8px;
}
</style>
